import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  NativeSelect,
  Select,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Header from "../../components/Header";
import ProjectModuleApi from "../../services/api/ProjectModules";

function ProjectModuleForm({
  formData,
  projects,
  moduleCategories,
  open,
  handleClose,
}) {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isEdit, setIsEdit] = useState(false);

  const modalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const preventCloseBackdrop = (props) => (
    <div {...props} style={{ pointerEvents: "none" }} />
  );

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: checkoutSchema,

    onSubmit: async (values, { resetForm }) => {
      console.log(values);
      if (isEdit) {
        editEntity(values);
      } else {
        createEntity(values);
      }

      resetForm();
    },
  });

  useEffect(() => {
    if (formData) {
      formik.setValues({
        ...formData,
      });

      setIsEdit(true);
    } else {
      formik.setValues({
        ...initialValues,
      });
      setIsEdit(false);
    }
  }, [formData]);

  const createEntity = async (values) => {
    const response = await ProjectModuleApi().create(values);

    console.log(createdSuccessMsg, response);
    handleClose();
  };

  const editEntity = async (values) => {
    const response = await ProjectModuleApi().edit(formData.id, values);

    console.log(updatedSuccessMsg, response);
    handleClose();
  };

  const modalBody = (
    <Box
      sx={{
        width: "30%",
        bgcolor: "background.paper",
        padding: "15px",
        borderRadius: "8px",
      }}
    >
      <Header title={`${formName} `} />

      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            marginTop: "15px",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
          }}
        >
          <FormControl fullWidth>
            <Select
              value={formik.values.project_id || ""}
              onChange={formik.handleChange}
              name="project_id"
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <span className="placeholder-text">Select Project</span>
                  );
                }
                return projects?.find((p) => p.id === selected)?.name;
              }}
            >
              <MenuItem value="" disabled>
                Select Project
              </MenuItem>

              {projects.map((project) => (
                <MenuItem key={project.id} value={project.id}>
                  {project.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <Select
              value={formik.values.category_id || ""}
              onChange={formik.handleChange}
              name="category_id"
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <span className="placeholder-text">Select Category</span>
                  );
                }
                return moduleCategories?.find((c) => c.id === selected)?.name;
              }}
            >
              <MenuItem value="" disabled>
                Select Category
              </MenuItem>

              {moduleCategories.map((row) => (
                <MenuItem key={row.id} value={row.id}>
                  {row.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Name"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="name"
            value={formik.values.name}
            inputProps={{ maxLength: 50 }}
            error={!!formik.touched.name && !!formik.errors.name}
            helperText={formik.touched.name && formik.errors.name}
            sx={{ gridColumn: "span 4" }}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="path"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="path"
            value={formik.values.path}
            inputProps={{ maxLength: 50 }}
            error={!!formik.touched.path && !!formik.errors.path}
            helperText={formik.touched.path && formik.errors.path}
            sx={{ gridColumn: "span 4" }}
          />

          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Order No"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="order_no"
            value={formik.values.order_no}
            inputProps={{ maxLength: 10 }}
            error={!!formik.touched.order_no && !!formik.errors.order_no}
            helperText={formik.touched.order_no && formik.errors.order_no}
            sx={{ gridColumn: "span 1" }}
          />

          <TextField
            fullWidth
            variant="outlined"
            type="text"
            label="Icon"
            autoComplete="off"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            name="icon"
            value={formik.values.icon}
            inputProps={{ maxLength: 50 }}
            error={!!formik.touched.icon && !!formik.errors.icon}
            helperText={formik.touched.icon && formik.errors.icon}
            sx={{ gridColumn: "span 1" }}
          />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="end"
            mt="15px"
            gap={2}
          >
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              sx={{
                border: "1px solid var(--color-secondary-200)",

                "&:hover": {
                  backgroundColor: "var(--color-secondary-100)",
                  border: "1px solid var(--color-secondary-100)",
                  color: "var(--color-secondary-400)",
                },
              }}
            >
              Close
            </Button>
            <Button type="submit" variant="contained">
              {isEdit ? `Update ${formName}` : `Create New ${formName}`}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      style={modalStyle}
      //   BackdropComponent={preventCloseBackdrop}
    >
      {modalBody}
    </Modal>
  );
}

const checkoutSchema = yup.object().shape({
  project_id: yup.number().required("required"),
  category_id: yup.number().required("required"),
  name: yup
    .string()
    .required("required")
    .max(100, "Maximum characters limit exceeds"),
  path: yup
    .string()
    .required("required")
    .max(100, "Maximum characters limit exceeds"),
  order_no: yup.number().required("required"),
});

const initialValues = {
  project_id: "",
  category_id: "",
  name: "",
  path: "",
  order_no: "",
  icon: "RadioButtonCheckedIcon",
};

const formName = "Project Module";
const createdSuccessMsg = `${formName} created:`;
const updatedSuccessMsg = `${formName} updated:`;

export default ProjectModuleForm;
